import { useTranslation } from 'react-i18next';
import { Card } from '../common';

interface FCRTableProps {
  fcrTable: [number, number][];
}

export function FCRTable({ fcrTable }: FCRTableProps) {
  const { t } = useTranslation();

  return (
    <Card title={t('sidebar.fcrTableTitle')} padding="sm">
      <div className="max-h-96 overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-gray-50 dark:bg-gray-700">
            <tr>
              <th className="px-2 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300">
                {t('sidebar.weight')}
              </th>
              <th className="px-2 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300">
                {t('sidebar.targetFCR')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
            {fcrTable.map(([weight, fcr], index) => (
              <tr
                key={`fcr-${weight}-${index}`}
                className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                <td className="px-2 py-1.5 text-gray-900 dark:text-gray-100">
                  {weight.toFixed(3)}
                </td>
                <td className="px-2 py-1.5 text-gray-900 dark:text-gray-100">
                  {fcr.toFixed(3)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
